module.exports = __webpack_public_path__ + "media/icons/key-cmd-h-4135ef16.svg";